import { registerLocaleData } from '@angular/common';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import localePl from '@angular/common/locales/pl';

registerLocaleData(localePl);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
